import React from 'react'
import { Dropdown } from 'react-bootstrap'
import { useHistory, useUser } from '@ztechapps/common.hook'
import { Avatar, HorizontalStack, Icon } from '@ztechapps/webui.util'
import { AppVersion } from '@ztechapps/webui.page'
import { routesDef } from '../../../config/routes'
export default function Profile() {
  const { user, logout } = useUser()
  const picture = user?.profile.picture
  const name = user?.profile.name ?? ''
  const email = user?.profile.email ?? ''
  const history = useHistory()

  return (
    <Dropdown className="nav-item pe-3" align="end">
      <Dropdown.Toggle style={{ cursor: 'pointer' }} as="div">
        <Avatar src={picture} name={name} />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Header>
          <div className="fw-bold">{name}</div>
          <div>{email}</div>
          <AppVersion />
        </Dropdown.Header>

        <Dropdown.Divider />
        <Dropdown.Item onClick={() => history.push(routesDef.SettingsPage.path)}>
          <HorizontalStack gap={1}>
            <Icon name="gear" />
            <span>Settings</span>
          </HorizontalStack>
        </Dropdown.Item>

        <Dropdown.Divider />
        <Dropdown.Item onClick={() => logout()}>
          <HorizontalStack gap={1}>
            <Icon name="sign-out" /> <span>Logout</span>
          </HorizontalStack>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  )
}
